export default [
  {
    name: 'setting-flight-blocks',
    path: '/settings/flight-blocks',
    component: () => import(/* webpackChunkName: "flight-blocks" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Bloqueios Aéreos',
      icon: 'mdi mdi-airplane',
      label: 'Configurações gerais',
      roles: ['Admin']
    }
  }
]
